// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2AgBI","containerItemsCenter":"Skeleton_containerItemsCenter__2siEJ"};